import { useEffect } from "react";
import { store } from "utils/@reduxjs/store";

export const useInjectSaga = (key, saga) => {
  useEffect(() => {
    store.injectSaga(key, saga);
  }, [key, saga]);
};
